import BaseRepository, { PagedListResponse } from './base-repository';

import { get } from '@/helpers/http';
import { SortType } from '@/transformers/sort-by';
import { User, User$Details, User$Counters } from '@/types/User';

interface UsersQueryParams {
  q: string;
  sortField: string;
  sortType: SortType;
  offset: number;
  count: number;
}

if (process.env.VUE_APP_MOCK_API === 'yes') {
  (function _bootstrap() {
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    const adapert = require('../mocks/index').default;
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    const fnc = require('../mocks/users').default;
    fnc(adapert);
  })();
}

export default class UsersRepository extends BaseRepository<
  User$Details,
  UsersQueryParams,
  PagedListResponse<User>
> {
  constructor() {
    super('/user');
  }

  public async removeUserpic({ id }: User) {
    return this.undo(id, 'userpic');
  }

  public getCounters(id: string): Promise<User$Counters> {
    return get(`${this._resource}/${id}/counters`);
  }

  public uploadUserpic(file: File, { id }: User) {
    return this._upload(file, `${id}/userpic`);
  }
}
